import { useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { ShieldCheck, Loader2, ArrowLeft, MailCheck } from "lucide-react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      formatApiError(err);
      setSent(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        <div className="flex flex-col items-center mb-8">
          <div className="w-14 h-14 rounded-2xl bg-emerald-500 flex items-center justify-center mb-4">
            <ShieldCheck className="w-8 h-8 text-black" />
          </div>
          <h1 className="font-heading text-2xl font-extrabold text-slate-900">Mot de passe oublié</h1>
        </div>
        {sent ? (
          <div className="bg-white border border-slate-200 rounded-2xl p-8 text-center">
            <MailCheck className="w-10 h-10 text-emerald-600 mx-auto mb-3" />
            <p className="text-sm text-slate-700">Si un compte existe pour cette adresse, un email de réinitialisation vient d'être envoyé. Vérifiez votre boîte de réception (et les spams). Le lien expire dans 1 heure.</p>
            <a href="/login" className="inline-flex items-center gap-1 text-emerald-600 hover:underline mt-4 text-sm"><ArrowLeft className="w-4 h-4" /> Retour à la connexion</a>
          </div>
        ) : (
          <form onSubmit={submit} className="bg-white border border-slate-200 rounded-2xl p-6 sm:p-8 space-y-5" data-testid="forgot-form">
            <p className="text-sm text-slate-500">Saisissez votre adresse email. Nous vous enverrons un lien de réinitialisation.</p>
            <div className="space-y-2">
              <Label className="text-slate-700">Adresse email</Label>
              <Input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="forgot-email" className="bg-slate-50 border-slate-200 h-11" />
            </div>
            <Button type="submit" disabled={loading} data-testid="btn-forgot" className="w-full h-11 bg-emerald-500 hover:bg-emerald-600 text-black font-semibold">
              {loading && <Loader2 className="w-4 h-4 animate-spin mr-2" />}Envoyer le lien
            </Button>
            <a href="/login" className="flex items-center justify-center gap-1 text-slate-500 hover:text-slate-900 text-sm"><ArrowLeft className="w-4 h-4" /> Retour</a>
          </form>
        )}
      </div>
    </div>
  );
}
